import React, { useEffect, useState, useContext } from "react";
import { FaCaretDown } from "react-icons/fa";
import { Grid } from "@mui/material";
import CurrencyInput from "./input-elements/CurrencyInput";
import { EMS_OTHER_DEFAULT_FEE,PAYCHEX_OTHER_DEFAULT_FEE } from "../../../../constants";
import { EquipmentContext } from "../useContext/context";
import * as Yup from "yup";
import pricingValidation from "../pricing-validation";
import config from "../../../../config";


function DefaultFee({ form_data, setFormDataByKeyValue, errors }) {
    const [show_defaults, setShowDefaults] = useState(false);
    const { setErrors, org_id } = useContext(EquipmentContext);
    let default_fee = {};
    let other_default_fee = {};
    if (org_id == config.paymentcloud.PAYCHEX_ORG_ID) {
        other_default_fee = PAYCHEX_OTHER_DEFAULT_FEE;
        default_fee = pricingValidation.pricingValidation.paychex_default_fee;
    } else {
        other_default_fee = EMS_OTHER_DEFAULT_FEE;
        default_fee = pricingValidation.pricingValidation.default_fee;
    }

    const validationSchema = Yup.object().shape({
        setup_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Set Up Fee is required")
            .min(
                default_fee.setup_fee.minimum,
                `Please enter a fee of $${default_fee.setup_fee.minimum.toFixed(2)} or higher.`,
            ),

        monthly_access_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Monthly Access Fee is required")
            .min(
                default_fee.monthly_access_fee.minimum,
                `Please enter a fee of $${default_fee.monthly_access_fee.minimum.toFixed(2)} or higher.`,
            ),

        data_breach: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("$100k Data Breach is required")
            .min(
                default_fee.data_breach.minimum,
                `Please enter a fee of $${default_fee.data_breach.minimum.toFixed(2)} or higher.`,
            ),

        monthly_minimum: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Monthly Minimum is required")
            .min(
                default_fee.monthly_minimum.minimum,
                `Please enter a fee of $${default_fee.monthly_minimum.minimum.toFixed(2)} or higher.`,
            ),

        semi_annual_tech_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Semi-Annual Tech Fee is required")
            .min(
                default_fee.semi_annual_tech_fee.minimum,
                `Please enter a fee of $${default_fee.semi_annual_tech_fee.minimum.toFixed(2)} or higher.`,
            ),

        voice_aru: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Voice ARU is required")
            .min(
                default_fee.voice_aru.minimum,
                `Please enter a fee of $${default_fee.voice_aru.minimum.toFixed(2)} or higher.`,
            ),

        batch_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Batch Fee is required")
            .min(
                default_fee.batch_fee.minimum,
                `Please enter a fee of $${default_fee.batch_fee.minimum.toFixed(2)} or higher.`,
            ),

        ebt_transactions: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("EBT Transactions is required")
            .min(
                default_fee.ebt_transactions.minimum,
                `Please enter a fee of $${default_fee.ebt_transactions.minimum.toFixed(2)} or higher.`,
            ),

        avs_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("AVS Fee is required")
            .min(
                default_fee.avs_fee.minimum,
                `Please enter a fee of $${default_fee.avs_fee.minimum.toFixed(2)} or higher.`,
            ),

        auth_transaction: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("3rd Party Auth/Txn is required")
            .min(
                default_fee.auth_transaction.minimum,
                `Please enter a fee of $${default_fee.auth_transaction.minimum.toFixed(2)} or higher.`,
            ),

        monthly_cellular: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Monthly Cellular Txn is required")
            .min(
                default_fee.monthly_cellular.minimum,
                `Please enter a fee of $${default_fee.monthly_cellular.minimum.toFixed(2)} or higher.`,
            ),

        cellular_transaction: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Cellular/Txn is required")
            .min(
                default_fee.cellular_transaction.minimum,
                `Please enter a fee of $${default_fee.cellular_transaction.minimum.toFixed(2)} or higher.`,
            ),

        etf_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("ETF Fee is required")
            .min(
                default_fee.etf_fee.minimum,
                `Please enter a fee of $${default_fee.etf_fee.minimum.toFixed(2)} or higher.`,
            ),

        chargeback_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Chargeback Fee is required")
            .min(
                default_fee.chargeback_fee.minimum,
                `Please enter a fee of $${default_fee.chargeback_fee.minimum.toFixed(2)} or higher.`,
            ),

        representment_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Representment Fee is required")
            .min(
                default_fee.representment_fee.minimum,
                `Please enter a fee of $${default_fee.representment_fee.minimum.toFixed(2)} or higher.`,
            ),

        pre_dispute_fee: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Pre-Dispute Fee is required")
            .min(
                default_fee.pre_dispute_fee.minimum,
                `Please enter a fee of $${default_fee.pre_dispute_fee.minimum.toFixed(2)} or higher.`,
            ),

        returned_ach_item: Yup.number()
            .transform((value, originalValue) => (originalValue === "" ? 0 : value))
            .required("Returned ACH Item is required")
            .min(
                default_fee.returned_ach_item.minimum,
                `Please enter a fee of $${default_fee.returned_ach_item.minimum.toFixed(2)} or higher.`,
            ),
    });
    const handleOnChange = (e) => {
        try {
            e?.persist();
        } catch (error) {}
        setFormDataByKeyValue(e.target.name, e.target.value);
        validationSchema
            .validateAt(e.target.name, { [e.target.name]: e.target.value })
            .then((e) => {
                // nothing here
            })
            .catch((err) => {
                let validation_errors = errors;
                validation_errors = {
                    ...validation_errors,
                    [e.target.name]: err.errors,
                };
                setErrors(validation_errors);
            });
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setShowDefaults(!show_defaults);
        }
    };

    useEffect(() => {
        if (Object.entries(errors).length > 0) {
            setShowDefaults(true);
        }
    }, [errors]);

    return (
        <div className="default-fee">
            <div className="w-fit-content mt-2r">
                <h5
                    tabIndex="0"
                    role="button"
                    onKeyDown={handleKeyDown}
                    onClick={(_e) => setShowDefaults(!show_defaults)}
                >
                    {show_defaults
                        ? "Hide other fee defaults"
                        : "View other fee defaults"}
                    <FaCaretDown
                        style={
                            show_defaults ? { transform: "rotate(180deg)" } : {}
                        }
                    />
                </h5>
            </div>
            {show_defaults && (
                <>
                    <Grid container spacing={2} className="mt-2r">
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Set Up Fee"
                                placeholder={other_default_fee.setup_fee}
                                value={form_data.setup_fee}
                                name={"setup_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.setup_fee &&
                                Array.isArray(errors.setup_fee) &&
                                errors.setup_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Monthly Access Fee"
                                placeholder={
                                    other_default_fee.monthly_access_fee
                                }
                                value={form_data.monthly_access_fee}
                                name={"monthly_access_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.monthly_access_fee &&
                                Array.isArray(errors.monthly_access_fee) &&
                                errors.monthly_access_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="$100k Data Breach"
                                placeholder={other_default_fee.data_breach}
                                value={form_data.data_breach}
                                name={"data_breach"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.data_breach &&
                                Array.isArray(errors.data_breach) &&
                                errors.data_breach.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Monthly Minimum"
                                placeholder={
                                    other_default_fee.monthly_minimum
                                }
                                value={form_data.monthly_minimum}
                                name={"monthly_minimum"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.monthly_minimum &&
                                Array.isArray(errors.monthly_minimum) &&
                                errors.monthly_minimum.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className="mt-2r">
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Semi-Annual Tech Fee"
                                placeholder={
                                    other_default_fee.semi_annual_tech_fee
                                }
                                value={form_data.semi_annual_tech_fee}
                                name={"semi_annual_tech_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.semi_annual_tech_fee &&
                                Array.isArray(errors.semi_annual_tech_fee) &&
                                errors.semi_annual_tech_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Voice ARU"
                                endAdornment="/auth"
                                placeholder={other_default_fee.voice_aru}
                                value={form_data.voice_aru}
                                name={"voice_aru"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.voice_aru &&
                                Array.isArray(errors.voice_aru) &&
                                errors.voice_aru.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Batch Fee"
                                placeholder={other_default_fee.batch_fee}
                                value={form_data.batch_fee}
                                name={"batch_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.batch_fee &&
                                Array.isArray(errors.batch_fee) &&
                                errors.batch_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Returned ACH Item"
                                placeholder={
                                    other_default_fee.returned_ach_item
                                }
                                value={form_data.returned_ach_item}
                                name={"returned_ach_item"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.returned_ach_item &&
                                Array.isArray(errors.returned_ach_item) &&
                                errors.returned_ach_item.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className="mt-2r">
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="AVS Fee"
                                endAdornment="/txn"
                                placeholder={other_default_fee.avs_fee}
                                value={form_data.avs_fee}
                                name={"avs_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.avs_fee &&
                                Array.isArray(errors.avs_fee) &&
                                errors.avs_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="3rd Party Auth/Txn"
                                endAdornment="/txn"
                                placeholder={
                                    other_default_fee.auth_transaction
                                }
                                value={form_data.auth_transaction}
                                name={"auth_transaction"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.auth_transaction &&
                                Array.isArray(errors.auth_transaction) &&
                                errors.auth_transaction.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        {/* <Grid item xs={6} md={3}>
              <CurrencyInput label="Monthly Cellular Txn" placeholder={EMS_OTHER_DEFAULT_FEE.monthly_cellular} value={form_data.monthly_cellular} name={"monthly_cellular"} type="number" onChange={handleOnChange} errors={errors}  />
              {errors?.monthly_cellular && Array.isArray(errors.monthly_cellular) && errors.monthly_cellular.map(error => (
                <span className="error-message" >{error}</span>
              ))}
            </Grid>
            <Grid item xs={6} md={3}>
              <CurrencyInput label="Cellular/Txn" endAdornment="/txn" placeholder={EMS_OTHER_DEFAULT_FEE.cellular_transaction} value={form_data.cellular_transaction} name={"cellular_transaction"} type="number" onChange={handleOnChange} errors={errors}  />
              {errors?.cellular_transaction && Array.isArray(errors.cellular_transaction) && errors.cellular_transaction.map(error => (
                <span className="error-message" >{error}</span>
              ))}
            </Grid> */}
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="ETF Fee"
                                placeholder={other_default_fee.etf_fee}
                                value={form_data.etf_fee}
                                name={"etf_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.etf_fee &&
                                Array.isArray(errors.etf_fee) &&
                                errors.etf_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Chargeback Fee"
                                placeholder={
                                    other_default_fee.chargeback_fee
                                }
                                value={form_data.chargeback_fee}
                                name={"chargeback_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.chargeback_fee &&
                                Array.isArray(errors.chargeback_fee) &&
                                errors.chargeback_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className="mt-2r">
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Representment Fee"
                                placeholder={
                                    other_default_fee.representment_fee
                                }
                                value={form_data.representment_fee}
                                name={"representment_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.representment_fee &&
                                Array.isArray(errors.representment_fee) &&
                                errors.representment_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <CurrencyInput
                                label="Pre-Dispute Fee"
                                placeholder={
                                    other_default_fee.pre_dispute_fee
                                }
                                value={form_data.pre_dispute_fee}
                                name={"pre_dispute_fee"}
                                type="number"
                                onChange={handleOnChange}
                                errors={errors}
                            />
                            {errors?.pre_dispute_fee &&
                                Array.isArray(errors.pre_dispute_fee) &&
                                errors.pre_dispute_fee.map((error) => (
                                    <span className="error-message">
                                        {error}
                                    </span>
                                ))}
                        </Grid>
                    </Grid>
                </>
            )}
        </div>
    );
}

export default DefaultFee;
